/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.14.0
 * source: page_result.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./google/protobuf/any";
import * as pb_1 from "google-protobuf";
export namespace onlyone {
    export class Page extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            page?: number;
            pageSize?: number;
            totalPages?: number;
            totalSize?: number;
            content?: dependency_1.google.protobuf.Any[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("totalSize" in data && data.totalSize != undefined) {
                    this.totalSize = data.totalSize;
                }
                if ("content" in data && data.content != undefined) {
                    this.content = data.content;
                }
            }
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get totalSize() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set totalSize(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get content() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_1.google.protobuf.Any, 5) as dependency_1.google.protobuf.Any[];
        }
        set content(value: dependency_1.google.protobuf.Any[]) {
            pb_1.Message.setRepeatedWrapperField(this, 5, value);
        }
        static fromObject(data: {
            page?: number;
            pageSize?: number;
            totalPages?: number;
            totalSize?: number;
            content?: ReturnType<typeof dependency_1.google.protobuf.Any.prototype.toObject>[];
        }): Page {
            const message = new Page({});
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.totalSize != null) {
                message.totalSize = data.totalSize;
            }
            if (data.content != null) {
                message.content = data.content.map(item => dependency_1.google.protobuf.Any.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                page?: number;
                pageSize?: number;
                totalPages?: number;
                totalSize?: number;
                content?: ReturnType<typeof dependency_1.google.protobuf.Any.prototype.toObject>[];
            } = {};
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.totalSize != null) {
                data.totalSize = this.totalSize;
            }
            if (this.content != null) {
                data.content = this.content.map((item: dependency_1.google.protobuf.Any) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.page != 0)
                writer.writeInt32(1, this.page);
            if (this.pageSize != 0)
                writer.writeInt32(2, this.pageSize);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.totalSize != 0)
                writer.writeInt64(4, this.totalSize);
            if (this.content.length)
                writer.writeRepeatedMessage(5, this.content, (item: dependency_1.google.protobuf.Any) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Page {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Page();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.page = reader.readInt32();
                        break;
                    case 2:
                        message.pageSize = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.totalSize = reader.readInt64();
                        break;
                    case 5:
                        reader.readMessage(message.content, () => pb_1.Message.addToRepeatedWrapperField(message, 5, dependency_1.google.protobuf.Any.deserialize(reader), dependency_1.google.protobuf.Any));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): Page {
            return Page.deserialize(bytes);
        }
    }
}
